module.exports = __webpack_public_path__ + "img/black_cabinet.dabede4f.svg";